import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { whitelistQueryString } from '../queryStringUtils';

const isSameOrigin = () => {
  try {
    return !!window.parent.location.hostname;
  } catch (e) {
    return false;
  }
};

const onSameOriginHistoryChange = ({ pathname, search }) => {
  // Replace history state instead of mutating the parent hash not to break
  // the back button. Doing the latter would require the user to press back
  // twice to affect the iframe location.
  // Note that the state and title parameters are set to undefined. It is a
  // bit uncertain the different browser quirks how this will be handled.
  const url = `${window.parent.location.pathname}#${pathname}${whitelistQueryString(search)}`;
  window.parent.history.replaceState(undefined, undefined, url);
};

const onCrossOriginHistoryChange = ({ pathname, search }) => {
  window.parent.postMessage(pathname + whitelistQueryString(search), '*');
};

const useParentHistoryMutation = () => {
  const history = useHistory();
  useEffect(() => {
    const unlisten = (() => {
      if (window !== window.parent) {
        if (isSameOrigin()) {
          if (window.parent.location.hash.substr(2) !== '') {
            history.push(window.parent.location.hash.substr(1));
          }
          return history.listen(onSameOriginHistoryChange);
        }
        return history.listen(onCrossOriginHistoryChange);
      }
      return undefined;
    })();
    return () => {
      if (typeof unlisten === 'function') {
        unlisten();
      }
    };
  }, []);
};

export default useParentHistoryMutation;
